import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Header, List, Placeholder, ScrollView } from '$uikit';
import { Battle } from '$store/models';
import { Loader } from '$shared/components';
import { useTranslator } from '$hooks';
import { Api } from '$api';
import { toastActions } from '$store/toast';
import { mainActions } from '$store/main';
import { BattleItems } from '$core/Battles/BattleItems/BattleItems';
import { BATTLE } from '$shared/constants/pages';

export const Battles: React.FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const [loadingStatus, setLoadingStatus] = React.useState('loading');
  const [battles, setBattles] = React.useState<Battle[]>([]);

  const handleLoad = useCallback(() => {
    setLoadingStatus('loading');
    Api.get('/battle/list')
      .then((resp) => {
        const data: any = resp;
        dispatch(mainActions.setUsers(data.users));
        setBattles(data.battles);
        setLoadingStatus('');
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
        setLoadingStatus('failed');
      });
  }, []);

  useEffect(() => {
    handleLoad();
  }, []);

  function renderContent() {
    if (loadingStatus === 'loading') {
      return <Loader isWrapped />;
    }

    if (loadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={
            <Button size="small" onClick={handleLoad}>
              {t('failed_button')}
            </Button>
          }
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    return (
      <>
        <List>
          {battles.map((item) => (
            <BattleItems routeName={BATTLE} key={item.id} battle={item} />
          ))}
        </List>
      </>
    );
  }

  return (
    <>
      <Header showBackButton>{t('battles_title')}</Header>
      <ScrollView>{renderContent()}</ScrollView>
    </>
  );
};
